export default "__VITE_ASSET__Dz_IwFxJ__"